import * as TrackingBCT from '@otto-ec/tracking-bct';
const { submitEvent } = TrackingBCT;



function sendEventToTrackingServer (event: object) {
    const trackingEvent = createTrackingEvent(event);
    submitEvent(trackingEvent)
}

function createTrackingEvent(event: object) {
    const trackingEvent = {} as any;
    for (const [key, value] of Object.entries(event)) {
        trackingEvent[key] = Array.isArray(value) ? value : [value];
    }
    return trackingEvent;
}

export { sendEventToTrackingServer }